"use client"

import { VisionAndMissionProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const VisionAndMission = {
  label: "Tamda Group | Vision And Mission",
  fields: {
    topImage: {
      label: "Top Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    topItems: {
      label: "Top Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Item ${index + 1}: ${item?.number || ""} ${item?.text || ""}`,
      arrayFields: {
        number: {
          label: "Number",
          type: "text",
        },
        text: {
          label: "Text",
          type: "text",
        },
      },
    },
    topDescriptions: {
      label: "Top Descriptions",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Description ${index + 1}`,
      arrayFields: {
        text: {
          label: "Description",
          type: "textarea",
        },
      },
    },
    bottomImage: {
      label: "Bottom Image",
      type: "custom",
      render: props => <ImageUploadField {...props} />,
    },
    visionTitle: {
      label: "Vision Title",
      type: "text",
    },
    visionDescription: {
      label: "Vision Description",
      type: "textarea",
    },
    missionTitle: {
      label: "Mission Title",
      type: "text",
    },
    missionDescription: {
      label: "Mission Description",
      type: "textarea",
    },
    companyValues: {
      label: "Company Values",
      type: "array",
      getItemSummary: (item: any, index = 0) => `Value ${index + 1}: ${item?.title || ""}`,
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    topImage: "",
    topItems: [
      {
        number: "1",
        text: "TTTM Tamda",
      },
      {
        number: "2",
        text: "Trung tâm phân phối",
      },
      {
        number: "3",
        text: "Siêu thị Tamda Foods",
      },
    ],
    topDescriptions: [
      {
        text: "Hơn 500 đối tác và thương hiệu lớn nhỏ",
      },
      {
        text: "Mỗi một chi nhánh đón hơn 10 ngàn lượt khách hàng ghé thăm mỗi ngày",
      },
      {
        text: "Hơn 40 ngàn mặt hàng thực phẩm đang có mặt tại hệ thống siêu thị Tamda Foods",
      },
      {
        text: "Chương trình tri ân khách hàng lớn nhất trong năm - Tamda Promo diễn ra thường niên với tổng giá trị giải thưởng lên đến gần 5 triệu Korun",
      },
    ],
    bottomImage: "",
    visionTitle: "TẦM NHÌN",
    visionDescription:
      "Leading enterprise in the Czech Republic in the field of wholesale food, operating under modern trade, serving the Vietnamese retail business community in the Czech Republic. Determined to develop Tamda into a multinational corporation, expanding business operations in the Czech Republic, Europe, especially targeting the Vietnamese market. Tamda Group will become a solid bridge for economic and trade relations between Vietnam and the Czech Republic in particular, and between Vietnam and Europe in general.",
    missionTitle: "SỨ MỆNH",
    missionDescription:
      "Elevating the brand of Vietnamese enterprises in the Czech Republic, promoting and fostering Vietnamese and Asian brand products to access and establish themselves in the European market. All long-term cooperation is based on equality and harmonious benefits for all participating parties. We are committed to delivering real value.",
    companyValues: [
      {
        title: "Đối với khách hàng",
        description: "Emphasizes prioritizing customer needs and making customer success their goal.",
      },
      {
        title: "Đối với nhà đầu tư & đối tác",
        description:
          "Highlights equality, cooperative development, transparent financial and operational activities, and optimizing investment value.",
      },
      {
        title: "Đối với cộng đồng, xã hội",
        description:
          "Focuses on building a united and strong Vietnamese community in the Czech Republic, fulfilling corporate social responsibility, and sharing with the community and local people.",
      },
      {
        title: "Đối với cán bộ nhân viên",
        description:
          "Aims to create conditions, care for and improve the quality of life (both spiritual and material) for employees, and foster a favorable environment for employees to develop their strengths.",
      },
    ],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
} as ComponentConfig<VisionAndMissionProps>
